import { defineComponent as n, openBlock as o, createElementBlock as c, createElementVNode as e, createBlock as i, resolveDynamicComponent as a, toRaw as r, createCommentVNode as l, createVNode as m, withCtx as d, createTextVNode as h, toDisplayString as f, unref as w } from "vue";
import p from "../../../icons/generated/IconInfo.vue2.js";
import u from "./ScrollingContent.vue2.js";
/* empty css                      */
const v = { class: "flex max-w-full" }, x = { class: "bg-static-success-mid text-static-success-hi body-2-bold flex h-24 min-w-0 items-center px-2" }, V = /* @__PURE__ */ n({
  name: "RevCouponBody",
  __name: "CouponBody",
  props: {
    label: {},
    icon: {},
    withInfo: { type: Boolean }
  },
  setup(t) {
    return (g, s) => (o(), c("div", v, [
      s[0] || (s[0] = e("svg", {
        class: "shrink-0",
        height: "24",
        width: "5",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        e("path", {
          d: "M5 0H3.2C2.1 0 1.5 0 1.1.2a2 2 0 0 0-.9.9C0 1.5 0 2 0 3.2v4.9l.2.2.6.2c1.7.3 3 1.8 3 3.5s-1.3 3.2-3 3.5l-.6.2-.2.2v4.9c0 1.1 0 1.7.2 2.1.2.4.5.7.9.9.4.2 1 .2 2.1.2H5V0Z",
          fill: "hsl(145, 83%, 77%)"
        })
      ], -1)),
      e("div", x, [
        t.icon ? (o(), i(a(r(t.icon)), {
          key: 0,
          class: "size-16 shrink-0"
        })) : l("", !0),
        m(u, { class: "-mx-2" }, {
          default: d(() => [
            h(f(t.label), 1)
          ]),
          _: 1
        }),
        t.withInfo ? (o(), i(w(p), {
          key: 1,
          class: "relative",
          size: "16"
        })) : l("", !0)
      ]),
      s[1] || (s[1] = e("svg", {
        class: "shrink-0",
        height: "24",
        width: "5",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        e("path", {
          d: "M0 0h1.8c1.1 0 1.7 0 2.1.2.4.2.7.5.9.9.2.4.2 1 .2 2.1v4.9l-.2.2-.6.2c-1.7.3-3 1.8-3 3.5s1.3 3.2 3 3.5l.6.2.2.2v4.9c0 1.1 0 1.7-.2 2.1a2 2 0 0 1-.9.9c-.4.2-1 .2-2.1.2H0V0Z",
          fill: "hsl(145, 83%, 77%)"
        })
      ], -1))
    ]));
  }
});
export {
  V as default
};
